import { render, staticRenderFns } from "./ColumnCreated.vue?vue&type=template&id=0029ffe8&scoped=true"
import script from "./ColumnCreated.vue?vue&type=script&lang=js"
export * from "./ColumnCreated.vue?vue&type=script&lang=js"
import style0 from "./ColumnCreated.vue?vue&type=style&index=0&id=0029ffe8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0029ffe8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0029ffe8')) {
      api.createRecord('0029ffe8', component.options)
    } else {
      api.reload('0029ffe8', component.options)
    }
    module.hot.accept("./ColumnCreated.vue?vue&type=template&id=0029ffe8&scoped=true", function () {
      api.rerender('0029ffe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/List/ColumnCreated.vue"
export default component.exports